import { useSessionStorage } from "@pmag/ui-components";
import { Routes } from "@src/context/router/RouterContext";
import { useGlobalState } from "@src/hooks/useGlobalState";
import { useRouter } from "@src/hooks/useRouter";
import {
    defaultSessionFilterState,
    sessionFilterSchema,
    type SessionFilterState,
} from "@src/pages/compatibilityCheck/components/usageList/UsageListFormSchema";

export const useChangeModel = (): { changeModel: () => void; showChangeModelButton: boolean } => {
    const router = useRouter();
    const { searchTerm, breadcrumbs } = useGlobalState();
    const [appliedFilter] = useSessionStorage<SessionFilterState>("filter", defaultSessionFilterState, sessionFilterSchema);

    const isSearchTermSet = searchTerm.length > 0;
    const isCompatibilityCheckSet = appliedFilter.articleNumber != null || appliedFilter.articleDescription != null;
    const showChangeModelButton = isCompatibilityCheckSet || isSearchTermSet || breadcrumbs.length > 1;

    return {
        changeModel: () => {
            router.setRoute(isSearchTermSet ? Routes.SearchResult : isCompatibilityCheckSet ? Routes.CompatibilityCheck : Routes.VisualSelector);
        },
        showChangeModelButton,
    };
};
